// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import polyfill from './utils/polyfill'
// import { wxConfig } from './utils/jweixin'

Vue.use(VueRouter)
Vue.use(VueResource)
polyfill()
// wxConfig(Vue)

// 'http://localhost:8080'
// 'https://www.iyxy.cn:50060'
const httpRoot = ip + ':' + port

Vue.prototype.httpRoot = httpRoot

Vue.http.headers.common['Authorization'] = 'Basic YXBpOnBhc3N3b3Jk'
Vue.http.headers.common['Accept'] = 'application/json'
Vue.http.headers.common['Content-Type'] = 'application/json; charset=utf-8'

import routes from './router/routes'
import deviceMixin, { androidInputBugFix } from './utils/device'

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

window.onerror = function (msg, url, l) {
  var txt = ''
  txt = 'There was an error on this page.\n\n'
  txt += 'Error: ' + msg + '\n'
  txt += 'URL: ' + url + '\n'
  txt += 'Line: ' + l + '\n\n'
  txt += 'Click OK to continue.\n\n'
  alert(txt)
  return true
}

androidInputBugFix()
deviceMixin(Vue)

import store from './store'
import { updateDirection } from './store/actions'
import { updateStorageItem } from './utils/cache'
import { isMiniProgram } from './utils/isMiniProgram'

router.beforeEach((to, from, next) => {
  if (to.name === 'home' || to.name === 'followuplist') {
    if (to.query.token && to.query.patientId && to.query.subjectId) {
      store.dispatch('login', to.query.token)
      updateStorageItem('patientId', to.query.patientId)
      updateStorageItem('subjectId', to.query.subjectId)
      next()
    } else {
      if (isMiniProgram()) {
        window.wx.miniProgram.navigateBack()
      }
    }
  }
  updateDirection(store, from, to)
  next()
  // if (!finishedInfo() && to.name !== 'home' && to.name !== 'hello' && to.name !== 'finishinfo') {
  //   if (isMiniProgram()) {
  //     window.wx.miniProgram.navigateTo({url: '../finishinfo/finishinfo'})
  //   } else {
  //     updateDirection(store, from, to)
  //     router.push({name: 'finishinfo'})
  //     next(false)
  //   }
  // } else {
  //   updateDirection(store, from, to)
  //   next()
  // }
})

import App from './App'

/* eslint-disable no-new */
const app = new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
